import { useContext, useEffect, useState } from "react";
import GameFeedbackModal from "./gameFeedbackModal";
import { useHistory } from "react-router-dom";
import AuthContext from "../../../shared/context/authContext/AuthContext";
import { CustomManagementRole } from "../../../shared/enums/role.enum";
import { readJson } from "../../../shared/utils/storage";

const GameFeedbackComponent = () => {
    const { state } = useContext(AuthContext);
    const [showGameFeedbackModal, setShowGameFeedbackModal] = useState(false);
    const [gameLogId, setgameLogId] = useState(null);
    const history = useHistory();
    const role = state.user?.role ?? "UNKNOWN_ROLE";

    useEffect(() => {
        if (!["PARENT", "TEACHER"].includes(role) 
            || 
            ![CustomManagementRole.B2B_TEACHER, CustomManagementRole.B2B_PARENT, CustomManagementRole.B2B_STUDENT].includes(
                state.user?.group_role as CustomManagementRole
            )) {
            localStorage.removeItem("gameAssets");
            history.push("/app/lets-play");
            return;
        }

        const gameAssets = readJson<any>("gameAssets", {});
        if (gameAssets?.gameLogId) {
            setgameLogId(gameAssets.gameLogId);
            setShowGameFeedbackModal(true);
        } else {
            history.push("/app/lets-play");
        }
        // group_role is set in the same SET_USER update as role, so depending on role is enough.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, role]);
    
    return (
        <div className="flex justify-center">
            <GameFeedbackModal
                gameLogId={gameLogId}
                showModal={showGameFeedbackModal}
                onClose={() => {
                    setShowGameFeedbackModal(false);
                    try {
                        localStorage.removeItem("gameAssets");
                    } catch (error) {
                        console.error(error);
                    }
                    history.push("/app/lets-play");
                }}
            />
        </div>
    );
};

export default GameFeedbackComponent;
